module.exports = __webpack_public_path__ + "components/rewards/christy/static/icon-a6ca24a735a0670b8c6614c110deefa5.svg";